// extracted by mini-css-extract-plugin
export default {"mainContainer":"myorder_mainContainer__snHcV","orderHeading":"myorder_orderHeading__O14iU","orderListContainer":"myorder_orderListContainer__7-vhL"};